const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i

export function digitsOnly (value) {
  return String(value || '').replace(/\D/g, '')
}

export function validateEmail (value, required) {
  const trimmed = (value || '').trim()
  if (!trimmed) {
    return required ? 'required' : null
  }
  if (!EMAIL_RE.test(trimmed)) {
    return 'invalid'
  }
  return null
}

export function validatePhone (value, required) {
  const digits = digitsOnly(value)
  if (!digits) {
    return required ? 'required' : null
  }
  if (digits.length < 10 || digits.length > 15) {
    return 'invalid'
  }
  return null
}

export function validateRequiredText (value, required) {
  const trimmed = (value || '').trim()
  if (!trimmed && required) return 'required'
  return null
}

export function validateCnpj (value, required) {
  const trimmed = (value || '').trim()
  if (!trimmed) {
    return required ? 'required' : null
  }
  const digits = digitsOnly(trimmed)
  if (digits.length !== 14) {
    return 'invalid'
  }
  return null
}

export function validateCpfCnpj (value, required) {
  const trimmed = (value || '').trim()
  if (!trimmed) {
    return required ? 'required' : null
  }
  const digits = digitsOnly(trimmed)
  if (digits.length !== 11 && digits.length !== 14) {
    return 'cpfCnpj'
  }
  return null
}

export function formatPhoneBr (value) {
  const d = digitsOnly(value).slice(0, 13)
  if (!d) return ''
  if (d.length <= 2) return `(${d}`
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`
}

export function formatCnpj (value) {
  const d = digitsOnly(value).slice(0, 14)
  if (d.length <= 2) return d
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`
  if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`
  if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`
}

export function formatCpfCnpj (value) {
  const d = digitsOnly(value).slice(0, 14)
  if (d.length <= 11) {
    if (d.length <= 3) return d
    if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`
    if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`
    return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`
  }
  return formatCnpj(d)
}
